import moment from "moment";

const key = "showNotice";
export class UtilNotice {
  /**
   * 오늘하루 그만보기 세팅
   * @param userId 사용자 ID
   * @param noticeId 팝업 공지사항 ID
   */
  static setShowInfo(userId?: number, noticeId?: number) {
    if (!userId || userId < 0) return;

    if (!noticeId || noticeId < 0) return;

    const expiredDt = moment().add(1, "day").toISOString();
    localStorage.setItem(`${key}:${userId}:${noticeId}`, expiredDt);
  }

  /**
   * 오늘하루 그만보기 여부 조회
   * @param userId 사용자 ID
   * @param noticeId 팝업 공지사항 ID
   * @returns
   */
  static getShowInfo(userId: number, noticeId?: number) {
    if (!userId || userId < 0) return undefined;

    if (!noticeId || noticeId < 0) return undefined;

    const storage = localStorage.getItem(`${key}:${userId}:${noticeId}`);

    return storage || undefined;
  }

  /**
   * 오늘하루 그만보기 제거
   * @param userId 사용자 ID
   * @param noticeId 팝업 공지사항 ID
   */
  static deleteShowInfo(userId: number, noticeId?: number) {
    if (!userId || userId < 0) return;

    if (!noticeId || noticeId < 0) return;

    localStorage.removeItem(`${key}:${userId}:${noticeId}`);
  }

  /**
   * 기간만료 여부 체크
   * @param userId 사용자 ID
   * @param noticeId 팝업 공지사항 ID
   * @returns true: 만료
   */
  static checkExpiredInfo(userId: number, noticeId?: number) {
    if (!userId || userId < 0) return undefined;

    if (!noticeId || noticeId < 0) return undefined;

    const date = this.getShowInfo(userId, noticeId);
    const checked = moment().isAfter(date, "date");

    if (checked) {
      /**
       * 만료되었으면 자동 삭제
       * 불필요하다면 args에 옵션을 주거나, 따로 호출
       */
      this.deleteShowInfo(userId, noticeId);
    }

    return checked;
  }
}
